<template>
    <qld-component-player
        :data-qld-config="playerQldConfigAsString"
        data-qld-name="player"
        @player-loaded="playerReady"
    />
</template>
<script>
    import { mapGetters, mapMutations, mapState } from 'vuex';
    export default {
        name: 'LivePlayer',
        computed: {
            ...mapState('livePage', ['theatreMode']),
            ...mapGetters('project', [
                'showPollsOverVideo',
                'showQuizOverVideo',
                'showTheatreMode',
            ]),
            playerQldConfigAsString() {
                const playerQldConfig = {
                    width: '100%',
                    aspectratio: '16:9',
                    customUnmuteToggle: 'true',
                    customUnMuteLabel: this.$t('event.unmute_text'),
                    mute: 'true',
                    'allow-fullscreen':
                        !this.showPollsOverVideo &&
                        !this.showQuizOverVideo &&
                        (!this.showTheatreMode || this.isMobile),
                    theaterMode: this.playerConfigTheaterMode,
                };
                return JSON.stringify(playerQldConfig);
            },
            playerConfigTheaterMode() {
                if (this.showTheatreMode && !this.isMobile) {
                    return this.theatreMode ? 'on' : 'off';
                }
                return false;
            },
            isMobile() {
                return this.$vuetify.breakpoint.smAndDown;
            },
        },
        methods: {
            ...mapMutations('livePage', ['openSheet', 'setTheatreMode']),
            onTheaterMode(playerId, state) {
                this.setTheatreMode(state === 'on');
            },
            onForceFullScreen(p, v) {
                const liveSidebar = document.querySelector('.live-sidebar');
                const header = document.querySelector('.header');
                if (v) {
                    if (this.isMobile && liveSidebar) {
                        liveSidebar.style.display = 'none';
                    }
                    if (this.isMobile && header) {
                        header.classList.remove('d-flex');
                        header.style.display = 'none';
                    }

                } else {
                    if (this.isMobile && liveSidebar) {
                        liveSidebar.style.display = 'block';
                    }
                    if (this.isMobile && header) {
                        header.classList.add('d-flex');
                        header.style.display = 'flex';
                    }
                }
            },
            playerReady() {
                this.removePlayerListeners();
                window.QuadiaPlayer.$on('theaterMode', this.onTheaterMode);
                window.QuadiaPlayer.$on('forceFullscreen', this.onForceFullScreen);
            },
            removePlayerListeners() {
                if (window.QuadiaPlayer) {
                    window.QuadiaPlayer.$off('theaterMode', this.onTheaterMode);
                    window.QuadiaPlayer.$off('forceFullscreen', this.onForceFullScreen);
                }
            },
        },
        mounted() {
            if (this.showTheatreMode) {
                document.addEventListener('keydown', (event) => {
                    if (event.key === 'Escape') {
                        this.openSheet();
                    }
                });
            }
        },
        beforeDestroy() {
            this.removePlayerListeners();
        },
    };
</script>

<style lang="scss">
.jw-player {
  overflow: hidden;
}

div[data-qld-name="player"] img {
  width: 100%;
}
</style>
